export const SCHEME_MACHPRO_WITH_PRE = 'sailorc://keeta.com/machpro'
